import { withYjs } from '@slate-yjs/core';
import type { XmlText } from 'yjs';

import type { CollaborationRequiredEditor } from './collaboration-editor';
import { CollaborationEditor } from './collaboration-editor';
import { EDITOR_TO_LOCAL_CHANGES_IN_SLATE_TICK } from './constants';
import { INSIDE_NORMALIZATION } from '../with-apply';

export type CreateWithCollaborationOptions = {
  sharedRoot: XmlText;
};

export function createWithCollaboration({ sharedRoot }: CreateWithCollaborationOptions) {
  return <T extends CollaborationRequiredEditor>(editor: T) => {
    const e = withYjs(editor, sharedRoot, {}) as T & CollaborationEditor;

    e.__collaborationEditor = true;

    // LocalModificationOrigins = all changes that should be counted as local user interactions
    // LocalOrigins (from slate-yjs) = all slate changes that should be applied to the yjs document
    e.isLocalModificationOrigin = e.isLocalOrigin;

    const { apply } = editor;
    editor.apply = op => {
      if (CollaborationEditor.isLocalModification(e) && !INSIDE_NORMALIZATION.get(e)) {
        EDITOR_TO_LOCAL_CHANGES_IN_SLATE_TICK.set(e, true);
      }

      return apply(op);
    };

    const { onChange } = editor;
    editor.onChange = () => {
      // Unset the flag in microTask to ensure all onChange handlers have been called first
      queueMicrotask(() => {
        EDITOR_TO_LOCAL_CHANGES_IN_SLATE_TICK.set(e, false);
      });

      return onChange();
    };

    return e;
  };
}
